import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X, TrainFront } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setScrolled(latest > 50);
  });


  const links = [
    { name: "Über Mich", href: "/#about" },
    { name: "Projekte", href: "/#projects" },
    { name: "Hobbys", href: "/#hobbies" },
    { name: "Kontakt", href: "/#footer" }
  ];

  return (
    <motion.nav
      className={cn(
        "fixed top-0 left-0 w-full z-50 border-b transition-all duration-300 backdrop-blur-md",
        scrolled ? "bg-background/90 border-border py-4" : "bg-transparent border-transparent py-6"
      )}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <div className="p-2 bg-primary/10 border border-primary/20 rounded-sm group-hover:bg-primary group-hover:text-white transition-colors">
            <TrainFront className="w-6 h-6" />
          </div>
          <span className="font-display text-2xl font-bold tracking-widest text-foreground">
            XEAROX<span className="text-primary">.DE</span>
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="font-mono text-sm tracking-wider hover:text-primary transition-colors uppercase"
            >
              {link.name}
            </a>
          ))}

        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 text-foreground hover:text-primary"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden absolute top-full left-0 w-full bg-background border-b border-border p-4 flex flex-col gap-4"
        >
          {links.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="font-display text-lg py-2 border-b border-border/10 hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </a>
          ))}
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
